var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconTrashBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.832 17.5c-.458 0-.85-.163-1.177-.49a1.602 1.602 0 01-.49-1.177V5a.807.807 0 01-.594-.24.803.803 0 01-.239-.593c0-.236.08-.434.24-.595.16-.16.358-.24.593-.239H7.5c0-.236.08-.434.24-.594.16-.16.357-.24.593-.239h3.333c.237 0 .435.08.595.24.16.16.24.358.239.593h3.333c.236 0 .434.08.594.24.16.16.24.358.24.594s-.08.434-.24.594a.803.803 0 01-.594.239v10.833c0 .459-.163.851-.49 1.178-.327.326-.719.49-1.177.489H5.832zm0-12.5v10.833h8.333V5H5.832zm1.667 8.333c0 .236.08.434.24.595.16.16.357.24.593.239.236 0 .434-.08.594-.24.16-.16.24-.358.24-.594V7.5a.807.807 0 00-.24-.594.803.803 0 00-.594-.24.807.807 0 00-.594.24.803.803 0 00-.24.594v5.833zm3.333 0c0 .236.08.434.24.595.16.16.358.24.593.239.237 0 .435-.08.595-.24.16-.16.24-.358.239-.594V7.5a.807.807 0 00-.24-.594.803.803 0 00-.594-.24.807.807 0 00-.594.24.803.803 0 00-.239.594v5.833z",
    fill: "#393E4C"
  })));
}

export default SvgIconTrashBox;